module.exports = __webpack_public_path__ + "static/media/skyexch.c2643b93.svg";